import Swiper from "swiper";
import { EffectFade, FreeMode, Navigation, Thumbs } from "swiper/modules";
export default class SwiperGallery {
    constructor() {
        this.swiperGalleries = document.querySelectorAll('.swiper-gallery');
        this.init();
    }
    init() {
        this.swiperGalleries.forEach((gallery) => {
            const sliderSingle = gallery.querySelector('.swiper-gallery-single');
            const sliderThumbs = gallery.querySelector('.swiper-gallery-thumbs');
            const navigationNextEl = gallery.querySelector('.swiper-button-next');
            const navigationPrevEl = gallery.querySelector('.swiper-button-prev');
            let swiperThumbs = new Swiper(sliderThumbs, {
                loop: true,
                modules: [FreeMode],
                slidesPerView: 4,
                spaceBetween: 16,
                freeMode: true,
                watchSlidesProgress: true
            });
            let sliderSingleOptions = {
                modules: [Thumbs],
                loop: true,
                spaceBetween: 8,
                thumbs: {
                    swiper: swiperThumbs
                }
            };
            if (gallery.classList.contains('swiper-gallery-fade')) {
                sliderSingleOptions.modules.push(EffectFade);
                sliderSingleOptions["effect"] = "fade";
            }
            if (navigationNextEl) {
                sliderSingleOptions.modules.push(Navigation);
                sliderSingleOptions["navigation"] = {
                    nextEl: navigationNextEl,
                    prevEl: navigationPrevEl
                };
            }
            new Swiper(sliderSingle, sliderSingleOptions);
        });
    }
}
